import { TableSchema } from '../metadata-schema';
import { IndicatorNaamPrestatieanalyse } from '../enums/IndicatorNaamPrestatieanalyse';
import { VsoCluster } from '../enums/VsoCluster';

export const dim_ppv_percentiel_prestatie_vso: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "dim_ppv_percentiel_prestatie_vso",
	"description": "Definitie voor dimension tabel dim_ppv_percentiel_prestatie_vso uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.DimTable",
		"nl.topicus.cumlaude.metadata.table.Landelijk"
	],
	"properties": {
		"ppv_fun_nm_indicator": {
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": IndicatorNaamPrestatieanalyse
		},
		"ppv_fun_nm_schooljaar": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ppv_fun_nm_cluster": {
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": VsoCluster
		},
		"ppv_is_prognose": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ppv_nm_indicator": {
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": IndicatorNaamPrestatieanalyse
		},
		"ppv_nm_schooljaar": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ppv_nm_cluster": {
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": VsoCluster
		},
		"ppv_nr_p25": {
			"type": "number",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ppv_nr_p50": {
			"type": "number",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ppv_nr_p75": {
			"type": "number",
			"filter": false,
			"grouping": false,
			"exportable": false
		}
	}
};
